module.exports = __webpack_public_path__ + "static/media/JMK01@l.1693643d.jpg";